<template>
  <div
    class="text-gray-900 hover:bg-gray-100 border border-solid border-gray-200 px-7px md:px-2 py-1 mr-2 rounded-full cursor-pointer ds-text-sm md:ds-text-base"
    data-test-id="toggle-cta"
    @click="close"
  >
    <Icon ref="icon" name="chevron-left" />
  </div>
</template>
<script>
import { defineComponent } from 'vue'
import { Icon } from "@sportsrecruits/playbook";

export default defineComponent({
  name: "DismissButton",
  components: { Icon },
  methods: {
    close() {
      this.$emit("close");
    },
  },
})
</script>

<style scoped>
.px-7px {
  padding-left: 7px;
  padding-right: 7px;
}
</style>
